export const cardContainerHeightCss = (
  isNetworkAlertIndicator,
  isInNetworkBadge,
  displayInNetworkBadgeEnabled,
  isCurrentMemberPreEffective
) =>
  isNetworkAlertIndicator ||
  (displayInNetworkBadgeEnabled &&
    isCurrentMemberPreEffective &&
    isInNetworkBadge)
    ? {
        height: '250px',
        '@media (max-width: 464px)': { width: '320px', height: '230px' },
      }
    : '';

export const cardContainerBorderCss = (enableMapEnhancements, popup = false) =>
  enableMapEnhancements
    ? {
        '&.active': {
          border: popup
            ? '2px solid transparent'
            : '2px solid $core.color.brand.80',
        },
      }
    : '';

export const cardHeightForSmartChoice = (
  isSmartChoice = false,
  enableHideMapViewOption = false,
  isUmr = false,
  popupContainerAndShowPcpBadge = false
) =>
  isSmartChoice && isUmr && !enableHideMapViewOption
    ? {
        minHeight: '280px',
        '@media (max-width: 744px)': { minHeight: '290px !important' },
      }
    : isSmartChoice && isUmr
    ? {
        minHeight: '280px !important',
      }
    : isSmartChoice && !enableHideMapViewOption
    ? popupContainerAndShowPcpBadge
      ? {
          minHeight: '280px !important',
        }
      : {
          minHeight: '250px !important',
        }
    : enableHideMapViewOption
    ? {
        minHeight: '180px !important',
      }
    : popupContainerAndShowPcpBadge ? {
        minHeight: '260px !important',
      } : {
        minHeight: '230px !important',
      };
export const renderWidth = (
  isPlatinumProvider: boolean | undefined,
  popupContainer: boolean
) => (isPlatinumProvider && popupContainer ? { width: 'auto !important' } : {});

export const getOpenCompareShare = (openCompare: boolean, openShare: boolean) =>
  openCompare || openShare;

export const getTranslatedText = (heading: any, search: any, t: any) =>
  heading?.length ? t(`${heading}`) : t(`${search}`) || '';

export const getActionStr = (closeSidePanel: boolean) =>
  closeSidePanel ? 'open' : 'close';

export const getEnableMapPinRedesign = (
  enableMapPinRedesignFlag: boolean,
  forceMapPinRedesign: boolean
) => enableMapPinRedesignFlag || forceMapPinRedesign;

export const shouldShowDocASAP = (
  schedulingEnabled: boolean,
  docasapPracticeId: string | null | undefined
) => schedulingEnabled && !!docasapPracticeId;

export const conditionalHandler = (
  condition: boolean | undefined,
  handler: any
) => (!condition ? handler : undefined);

export const concatenateStrings = (
  ...strings: Array<string | undefined | null>
): string => strings?.filter(Boolean)?.join(' '); // Filters out undefined or falsy values and concatenates

export const getTelemetryCoverageType = (
  coverageType: string | undefined | null
): string => {
  switch (coverageType) {
    case 'M':
      return 'medical';
    case 'D':
      return 'dental';
    case 'V':
      return 'vision';
    case 'B':
      return 'behavioral';
    default:
      return 'other';
  }
};

export const isGuestWithPlan = (url?: string) =>
  url?.includes('/guest-with-plan') || false;

export const setVirtualCareListViewPageParam = (url: URL) => {
  url.searchParams.set('virtualCareListViewPage', 'true');
  // Update browser history without page reload
  window.history.pushState({}, '', url.toString());
};

export const getAllProvidersWithServiceType = (virtualCareProviders: any) => {
  if (Array.isArray(virtualCareProviders)) {
    return virtualCareProviders?.flatMap((obj) =>
      (obj?.providers || []).map((provider) => ({
        ...provider,
        serviceType: obj?.serviceType,
      }))
    );
  }
  return virtualCareProviders?.providers || [];
};
